const CenteredDiv = ({children}) => {


    return (
        <div className="col-12 h-100 py-lg-5 d-flex justify-content-center align-items-center">
            <div className="h-100 h-tab-60 h-tab-ls-75 col-12 col-tab-7 col-tab-ls-5 col-lg-4 bg-darkest rounded px-4 py-4 d-flex flex-column justify-content-around align-items-center" >
                {children}
            </div>
        </div>
    );
}

export default CenteredDiv;